import { render, staticRenderFns } from "./CreatedOriginalDocuments.vue?vue&type=template&id=24541c73&scoped=true"
import script from "./CreatedOriginalDocuments.vue?vue&type=script&lang=js"
export * from "./CreatedOriginalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24541c73",
  null
  
)

export default component.exports